module.exports = __webpack_public_path__ + "img/filter_icon_2.634b08b4.webp";